class GraphQLClient {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  getAccessToken() {
    return (
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken")
    );
  }

  async request(query, variables = {}, options = {}) {
    const { useAuth = true, ...fetchOptions } = options;

    const headers = {
      "Content-Type": "application/json",
      ...fetchOptions.headers,
    };

    if (useAuth) {
      const accessToken = this.getAccessToken();
      if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
      }
    }

    try {
      const response = await fetch(this.endpoint, {
        method: "POST",
        headers,
        body: JSON.stringify({
          query,
          variables,
        }),
        ...fetchOptions,
      });

      if (!response.ok) {
        throw new Error(`네트워크 에러 status: ${response.status}`);
      }

      const result = await response.json();

      if (result.errors) {
        throw new Error(result.errors.map((error) => error.message).join(", "));
      }

      return result.data;
    } catch (error) {
      console.error("GraphQL 요청 실패:", error);
      throw error;
    }
  }

  async query(query, variables = {}, options = {}) {
    return this.request(query, variables, options);
  }

  async mutation(mutation, variables = {}, options = {}) {
    return this.request(mutation, variables, options);
  }

  async publicQuery(query, variables = {}, options = {}) {
    return this.request(query, variables, { ...options, useAuth: false });
  }

  async publicMutation(mutation, variables = {}, options = {}) {
    return this.request(mutation, variables, { ...options, useAuth: false });
  }

  async requestWithToken(query, variables = {}, token, options = {}) {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    };

    return this.request(query, variables, {
      ...options,
      useAuth: false,
      headers,
    });
  }
}

const graphqlClient = new GraphQLClient(
  process.env.REACT_APP_GRAPHQL_ENDPOINT || "http://192.168.0.6:9001/graphql"
);

export default graphqlClient;
